import React from "react";
import { useFormContext } from "react-hook-form";
import { Input } from "../ui/input";

interface FormInputProps {
  name: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FormInput: React.FC<FormInputProps> = ({
  name,
  placeholder,
  onChange,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[name];

  return (
    <div>
      <Input
        {...register(name, {
          onChange: (e) => {
            onChange?.(e);
          },
        })}
        placeholder={placeholder}
      />
      {error && (
        <div className="text-red-400 text-sm mt-2">
          {error.message as string}
        </div>
      )}
    </div>
  );
};
